import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Web3 from 'web3';
import contractABI from '../../abi/ERC20.json'; // Adjust path as necessary
import Spline from '@splinetool/react-spline';
import gif from '../../assets/jET9FZ.gif';
import Swal from 'sweetalert2';



const FaucetContainer = styled.div`
  display: flex;
  background-image: url(${gif});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f4f4f4;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  background: linear-gradient(45deg, #e600e6, #ff33cc, #3333ff);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 2.5rem;
  color: transparent;
  font-family: 'Akaya Telivigala', cursive;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (min-width: 360px) {
    font-size: 2.5rem;
  }
`;

const Content = styled.p`
  font-size: 1.2rem;
  color: #fff;
  text-align: center;
  margin-top: 20px;
`;


const ClaimButton = styled.button`
  display: inline-block;
font-family: 'Akaya Telivigala', cursive;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  margin-top: 30px;

 display: inline-block;
  background-color: white;
  color: black;
  outline: none;
  border: none;
bottom: 10px;
  font-size: 24px;
  padding: 0.9rem 2.3rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  &:hover {
    transform: scale(0.9);
    
  }

  &::after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    border: 2px solid white;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    transition: all 0.2s ease;
  }

  &:hover::after {
    transform: translate(-50%, -50%) scale(1);
    padding: 0.3rem;
  }
`;

const SplineContainer = styled.div`
  width: 100%;

  /* To ensure it takes up the full width */
  @media (min-width: 768px) {
    /* Adjust this breakpoint as needed for desktop view */
    max-width: 600px; /* Set a maximum width for the Spline frame on desktop */
    margin-left: 250px; /* Center the Spline frame on desktop */
  }
  @media (min-width: 360px) {  
   
  }
`;





const TokenFaucet = () => {
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [account, setAccount] = useState(null);
  const [nextClaimTime, setNextClaimTime] = useState(0);

  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);

      const tokenContract = new web3Instance.eth.Contract(
        contractABI,
        '0x90018c09407475294b2Ae9eDe2539a563360339e'
      );
      setContract(tokenContract);

      window.ethereum.request({ method: 'eth_requestAccounts' })
        .then(accounts => {
          setAccount(accounts[0]);
          return tokenContract.methods.lastClaimTimes(accounts[0]).call();
        })
        .then(lastClaimTime => {
          setNextClaimTime(parseInt(lastClaimTime) * 1000 + 24 * 60 * 60 * 1000); // Adjust the interval as per contract
        })
        .catch(err => console.error(err));
    } else {
      console.error("Ethereum object not found, install MetaMask.");
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setNextClaimTime(prevTime => prevTime - 1000);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const claimTokens = () => {
    if (contract && account) {
      contract.methods.claimTokens().send({ from: account })
        .then(response => {
          console.log('Tokens claimed:', response);
          setNextClaimTime(Date.now() + 24 * 60 * 60 * 1000); // Reset the timer
         
          Swal.fire({
            title: 'Success!',
            text: 'Tokens have been successfully claimed! Come Back tomorrow for more!',
            icon: 'success',
            confirmButtonText: 'Great!',
            backdrop: true,
            toast: true,
            position: 'center',
            showConfirmButton: true,
            timer: 5000, // Auto close after 5 seconds
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
            // ... other options
          });
          
        })
        .catch(err => {
          console.error(err);
          // You can also use SweetAlert2 for error handling
          Swal.fire({
            title: 'Error!',
            text: 'Failed to claim tokens.',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        });
    }
  };

  const canClaim = Date.now() >= nextClaimTime;

  const formatTime = (milliseconds) => {
    let totalSeconds = Math.floor(milliseconds / 1000);
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    return `${hours}h ${minutes}m ${seconds}s`;
  };

  return (
    <FaucetContainer id="tokenfaucet">
      <Title>Psycho Gems Token Faucet</Title>
      <Content>This token faucet is designed to encourage community engagement.</Content>
      <Content>Contract Address: 0x90018c09407475294b2Ae9eDe2539a563360339e</Content>

      <SplineContainer>
        <Spline scene="https://prod.spline.design/9S5Dl86vXigDLCym/scene.splinecode" />
      </SplineContainer>
      <ClaimButton onClick={claimTokens} disabled={!canClaim}>
        {canClaim ? "Claim Tokens" : "Wait for Next Claim"}
      </ClaimButton>
      {!canClaim && <Content>Next claim in: {formatTime(nextClaimTime - Date.now())}</Content>}
    </FaucetContainer>
  );
};

export default TokenFaucet;